<template>
  <section class="orders">
    <div class="status">
      <div class="status__heading">
        <h1>
          Users
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon slot="activator" class="info-icon" v-on="on">mdi-information</v-icon>
            </template>
            <span>These items are separated by Full and Partial documents.</span>
            <br />
            <span>If there is an order that needs to be expedited, select Urgent and [process accordingly].</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <span class="refresh-btn">
                <v-icon
                  class="refresh-icon"
                  v-ripple
                  :color="'#a9a9a9'"
                  v-on="on"
                  @click="refresh"
                >mdi-refresh</v-icon>
              </span>
            </template>
            <span>Refresh data</span>
          </v-tooltip>
        </h1>
      </div>
      <div class="status__column">
        <div class="status__column-heading">VIEW BY STATUS</div>

        <a href @click="refresh()">
          <StatusItem link="/users" :active="allUsersActive" label="All Users">
            <template v-slot:icon>
              <v-icon :color="allUsersColor">mdi-account-circle</v-icon>
            </template>
          </StatusItem>
        </a>
        <a href @click="refresh()">
          <StatusItem link="/users/active" :active="activeUsersActive" label="Active">
            <template v-slot:icon>
              <v-icon :color="activeUsersColor">mdi-radiobox-marked</v-icon>
            </template>
          </StatusItem>
        </a>
        <a href @click="refresh()">
          <StatusItem link="/users/inactive" :active="inactiveUsersActive" label="Inactive">
            <template v-slot:icon>
              <v-icon :color="inactiveUsersColor">mdi-radiobox-blank</v-icon>
            </template>
          </StatusItem>
        </a>
        <a href @click="refresh()">
          <StatusItem link="/users/admin" :active="adminUsersActive" label="Admin">
            <template v-slot:icon>
              <v-icon :color="adminUsersColor">mdi-key</v-icon>
            </template>
          </StatusItem>
        </a>
      </div>
    </div>
    <div class="content">
      <div class="content__actions">
        <div class="content__actions-left">
          <div class="search">
            <div class="search-icon">
              <v-icon :color="'#a9a9a9'">mdi-magnify</v-icon>
            </div>
            <div class="search-input">
              <input v-model="search" type="text" placeholder="Search" />
            </div>
          </div>
        </div>
        <div class="content__actions-right">
          <div class="process">
            <v-btn @click="openUserModal()" class="process-new" :color="'#CB201F'">Add User</v-btn>
          </div>
        </div>
      </div>
      <UsersTable :search="search" :users="users" v-on:refresh="refresh" :loading="loading" />
    </div>
    <UserModal v-if="isUserOpen" v-on:close="closeUserModal" />
  </section>
</template>

<script>
import UsersTable from '../components/UsersTable.vue';
import StatusItem from '../components/StatusItem';
import UserModal from '../components/UserModal';
import API from '../services/API';

export default {
  name: 'orders',
  components: {
    UsersTable,
    StatusItem,
    UserModal,
  },
  data() {
    return {
      search: '',
      isUserOpen: false,
      users: [],
      loading: false,
    };
  },
  computed: {
    allUsersColor() {
      return this.$route.path === '/users' ? '#51b71b' : '#a9a9a9';
    },
    activeUsersColor() {
      return this.$route.path === '/users/active' ? '#51b71b' : '#a9a9a9';
    },
    inactiveUsersColor() {
      return this.$route.path === '/users/inactive' ? '#cb201f' : '#a9a9a9';
    },
    adminUsersColor() {
      return this.$route.path === '/users/admin' ? '#000' : '#a9a9a9';
    },
    allUsersActive() {
      return this.$route.path === '/users';
    },
    activeUsersActive() {
      return this.$route.path === '/users/active';
    },
    inactiveUsersActive() {
      return this.$route.path === '/users/inactive';
    },
    adminUsersActive() {
      return this.$route.path === '/users/admin';
    },
  },
  methods: {
    refresh() {
      this.loading = true;
      this.batches = [];
      API.get('/users')
          .then((users) => {
            console.log(users);
            switch (this.$route.path) {
              case '/users/active':
                this.users = users.data.filter((user) => user.active);
                break;
              case '/users/inactive':
                this.users = users.data.filter((user) => !user.active);
                break;
              case '/users/admin':
                this.users = users.data.filter((user) => user.admin);
                break;
              default:
                this.users = users.data;
            }
          })
          .catch((error) => {
            console.error(error);
          })
          .then(() => (this.loading = false));
    },
    openUserModal() {
      this.isUserOpen = true;
    },
    closeUserModal() {
      this.refresh();
      this.isUserOpen = false;
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>

<style lang="scss" scoped>
@import "../main.scss";

.orders {
  padding: 1.5rem 0;
  width: 100%;
  min-width: 1200px;
  max-width: 2880px;
  height: 100%;
  background: #fff;
  display: grid;
  grid-template-columns: 320px 1fr 60px;

  .status {
    height: 100%;

    display: flex;
    flex-wrap: wrap;

    &__heading {
      height: 10rem;
      width: 100%;
      z-index: 1;

      display: flex;
      justify-content: center;
      align-items: center;

      h1 {
        height: 4.7rem;
        width: 17rem;
        color: #212121;
        font-family: Heebo;
        font-size: 3.2rem;
        font-weight: bold;
        line-height: 4.7rem;
        padding-right: 10px;

        .info-icon {
          font-size: 18px;
          margin-bottom: 1.4rem;
        }
      }

      .refresh-btn {
        border: 2px solid #dedede;
        border-radius: 6px;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 35px;
        width: 35px;
        margin-top: 4px;
        float: right;
      }
    }

    &__column {
      width: 100%;
      height: 100%;
      z-index: 5;

      &-heading {
        margin: 0 auto;
        height: 2.1rem;
        margin-top: 1.7rem;
        margin-bottom: 1.5rem;
        width: 17rem;
        color: #212121;
        font-family: Heebo;
        font-size: 1.4rem;
        font-weight: bold;
        letter-spacing: 1.24px;
        line-height: 2.1rem;
      }

      .divider {
        width: 17rem;
        height: 0.1rem;
        border-bottom: 2px solid #a9a9a9;
        margin: 0.5rem auto;
      }

      & > a {
        text-decoration: none;
      }
    }
  }

  .content {
    height: 100%;
    padding: 0;

    display: flex;
    flex-direction: column;

    &__actions {
      height: 10rem;
      width: 100%;

      display: flex;

      &-left {
        width: 50%;
        height: 100%;

        display: flex;
        align-items: center;

        .search {
          min-width: 27rem;
          width: 100%;
          height: 3.9rem;
          border: 2px solid #dedede;
          border-radius: 6px;

          display: flex;
          flex-direction: row;

          &-icon {
            width: 3.5rem;
            height: 100%;
            padding-left: 0.5rem;
            display: block;

            display: flex;
            align-items: center;
          }

          &-input {
            width: 100%;
            height: 100%;
            display: block;

            display: flex;
            align-items: center;
            border-radius: 6px;

            input {
              width: 100%;
              height: 100%;
              font-family: Heebo;
              font-size: 16px;
              line-height: 24px;

              &::placeholder {
                color: #a9a9a9;
              }

              &:focus {
                outline: none;
              }
            }
          }
        }
      }

      &-right {
        width: 50%;
        height: 100%;

        .process {
          width: 100%;
          height: 100%;

          display: flex;
          align-items: center;
          justify-content: flex-end;

          &-urgent,
          &-new {
            font-family: Heebo;
            letter-spacing: 0.5px;
            font-size: 1.5rem;
            line-height: 24px;
            text-align: center;
            text-transform: none;
            width: 48%;
          }

          &-urgent {
            height: 40px;
            min-width: 17.5rem;
            border-radius: 6px;
          }

          &-new {
            height: 40px;
            min-width: 14.5rem;
            border-radius: 6px;
            color: #fff;
          }
        }
      }
    }
  }
}
</style>
